/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_List_Export_BtnInputs */

const vi_lot_list_export_btn = /** @type {(inputs: Lot_List_Export_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel`)
};

/**

* @param {Lot_List_Export_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_list_export_btn = /** @type {((inputs?: Lot_List_Export_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_List_Export_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_list_export_btn(inputs)
});